<template>
    <button
        class="grid place-content-center cursor-pointer outline-none px-8 py-3 uppercase bg-tuvblue transition-all duration-200 hover:bg-tuvdarkblue border-2 border-tuvblue hover:border-tuvdarkblue text-tuvwhite"
    >
        <slot></slot>
    </button>
</template>
